import { render, staticRenderFns } from "./LookDetailServiceDetail.vue?vue&type=template&id=2440328e&scoped=true&"
import script from "./LookDetailServiceDetail.vue?vue&type=script&lang=js&"
export * from "./LookDetailServiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./LookDetailServiceDetail.vue?vue&type=style&index=0&id=2440328e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2440328e",
  null
  
)

export default component.exports